module.exports = __webpack_public_path__ + "static/media/SALA-CLINICA-3.036cd353.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/clinica/SALA-CLINICA-3.png
// module id = 162
// module chunks = 0